import { store, uid } from '@/firebase'
import { CollectionName, FSMemberShare } from '@WombatTechnology/nitte-time-lib'
import {
  CollectionReference,
  collection,
  collectionGroup,
  deleteDoc,
  doc,
  limit,
  query,
  setDoc,
  where
} from 'firebase/firestore'

export class MemberShare {
  static create(pageId: string, targetUid: string, teamId: string) {
    return setDoc(this.doc(uid()!, pageId, targetUid), {
      uid: targetUid,
      teamId
    })
  }

  static delete(pageId: string, targetUid: string) {
    return deleteDoc(this.doc(uid()!, pageId, targetUid))
  }

  static doc(ownerUid: string, bookingPageId: string, targetUid: string) {
    return doc(this.collection(ownerUid, bookingPageId), targetUid)
  }

  static collection(ownerUid: string, bookingPageId: string) {
    return collection(
      store,
      `${CollectionName.Users}/${ownerUid}/${CollectionName.BookingPages}/${bookingPageId}/${CollectionName.MemberShares}`
    ) as CollectionReference<FSMemberShare>
  }

  // 被共有側のページ一覧取得用。自分宛て(uid)かつ現在チーム(teamId)の共有を引く。
  static collectionQuery(targetUid: string, teamId: string) {
    return query(
      collectionGroup(store, CollectionName.MemberShares),
      where('uid', '==', targetUid),
      where('teamId', '==', teamId),
      limit(200)
    ) as CollectionReference<FSMemberShare>
  }
}
